/*!
 *
 *  hero.ts
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
;
export default function () {
    return __awaiter(this, void 0, void 0, function () {
        function setWidth() {
            var sliders = document.querySelectorAll('.top-slider');
            sliders.forEach(function (slider) {
                var width = 0;
                var items = slider.querySelectorAll('.top-slider__item');
                items.forEach(function (item, index) {
                    width += item.clientWidth;
                });
                slider.style.width = "".concat(width, "px");
            });
        }
        var questions, result, q, _loop_1, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    questions = document.querySelector('.top-questions');
                    ;
                    if (!questions) return [3 /*break*/, 2];
                    return [4 /*yield*/, axios.get('/wp-json/wp/v2/real_cats?hide_empty=1')];
                case 1:
                    result = _a.sent();
                    q = result.data;
                    _loop_1 = function (i) {
                        var div = document.createElement('div');
                        div.classList.add('top-slider');
                        var _q = q.sort(function () { return Math.random() - 0.5; });
                        var __q = __spreadArray(__spreadArray([], __read(_q), false), __read(_q), false);
                        __q.forEach(function (val) {
                            var item = document.createElement('div');
                            item.classList.add('top-slider__item');
                            var a = document.createElement('a');
                            a.href = val.link;
                            a.text = val.name;
                            item.appendChild(a);
                            div.appendChild(item);
                        });
                        questions.appendChild(div);
                        setWidth();
                    };
                    for (i = 0; i < 6; i++) {
                        _loop_1(i);
                    }
                    ;
                    window.addEventListener('load', setWidth);
                    window.addEventListener('resize', setWidth);
                    _a.label = 2;
                case 2:
                    ;
                    return [2 /*return*/];
            }
        });
    });
}
